/**
 * @desc 新增
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ListingQuoteRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/listingQuote/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
